import qc from 'qc'
import * as layoutScript from '@ps/bridge/qc/scripts/layout'
import store from '@ps/store'
import gameIframe from '@ps/bridge/iframe/iframe'

export function getPropByLayoutString(prop: string, layout: string): number {
  if (layout === '') {
    return 0
  }
  const arr = layout.split(',')
  for (const i in arr) {
    const arr2 = arr[i]?.split(':')
    if (arr2 && arr2[0] === prop) {
      return Number(arr2[1])
    }
  }
  return 0
}
export function getVisibleByLayoutString(layout: string): number {
  if (layout === '') {
    return 1
  }
  const arr = layout.split(',')
  for (const i in arr) {
    const arr2 = arr[i]?.split(':')
    if (arr2 && arr2[0] === 'visible') {
      return Number(arr2[1])
    }
  }
  return 1
}

export const removeUnSplitProInLayout = (node: qc.Node) => {
  const ped = node.getScript('playsmart.editor.data')
  ped.$data.unSplitProp = {
    visible: true,
    pivot: true,
    rotation: true,
  }
  const layout = node.getScript('ps.Layout')
  if (layout) {
    if (layout.layout.pdef !== '') {
      let temp = layout.layout.pdef.split(',')
      temp = temp.filter(
        (item: string) =>
          item.indexOf('visible') === -1 &&
          item.indexOf('pivotX') === -1 &&
          item.indexOf('pivotY') === -1 &&
          item.indexOf('rotation') === -1,
      )
      temp = temp.join(',')
      layout.layout.pdef = temp
    }
    if (layout.layout.ldef !== '') {
      let temp = layout.layout.ldef.split(',')
      temp = temp.filter(
        (item: string) =>
          item.indexOf('visible') === -1 &&
          item.indexOf('pivotX') === -1 &&
          item.indexOf('pivotY') === -1 &&
          item.indexOf('rotation') === -1,
      )
      temp = temp.join(',')
      layout.layout.ldef = temp
    }
  }
}
// 设置节点的指定的layout属性, style为json
export function setNodeStyleMerge(node: qc.Node, style) {
  const layoutScriptData = layoutScript.getScript(node)
  const layoutData = layoutScriptData.layoutData
  const layout = layoutScriptData.layout
  if (!layoutData.pdef) {
    layoutData.pdef = {}
  }
  if (!layoutData.ldef) {
    layoutData.ldef = {}
  }
  for (const i in style) {
    layoutData.pdef[i] = style[i]
    layoutData.ldef[i] = style[i]
  }
  const keyList = Object.keys(style)
  function parseLayout(str) {
    if (str === '') {
      const arr = []
      for (const i in style) {
        arr.push(`${i}:${style[i]}`)
      }
      return arr.join(',')
    }
    let arr = str.split(',')
    const obj = {}
    arr.forEach((item) => {
      const tarr = item.split(':')
      const key = tarr[0]
      obj[key] = tarr[1]
    })
    keyList.forEach((item) => {
      obj[item] = style[item]
    })
    arr = []
    for (const i in obj) {
      arr.push(`${i}:${obj[i]}`)
    }
    return arr.join(',')
  }
  layout.pdef = parseLayout(layout.pdef)
  layout.ldef = parseLayout(layout.ldef)
  layoutScriptData?.refresh()
}
// 设置节点指定的layout属性，区分横竖屏
export function setNodeStyleMergeVH(node: qc.Node, style) {
  const layoutScriptData = layoutScript.getScript(node)
  const layoutData = layoutScriptData.layoutData
  const layout = layoutScriptData.layout
  if (!layoutData.pdef) {
    layoutData.pdef = {}
  }
  if (!layoutData.ldef) {
    layoutData.ldef = {}
  }
  for (const i in style.pdef) {
    layoutData.pdef[i] = style.pdef[i]
  }
  for (const i in style.ldef) {
    layoutData.ldef[i] = style.ldef[i]
  }
  // const keyList = Object.keys(style)
  function parseLayout(str, type) {
    if (str === '') {
      const arr = []
      for (const i in style[type]) {
        arr.push(`${i}:${style[type][i]}`)
      }
      return arr.join(',')
    }
    let arr = str.split(',')
    const obj = {}
    arr.forEach((item) => {
      const tarr = item.split(':')
      const key = tarr[0]
      obj[key] = tarr[1]
    })
    const keyList = Object.keys(style[type])
    keyList.forEach((item) => {
      obj[item] = style[type][item]
    })
    arr = []
    for (const i in obj) {
      arr.push(`${i}:${obj[i]}`)
    }
    return arr.join(',')
  }
  layout.pdef = parseLayout(layout.pdef, 'pdef')
  layout.ldef = parseLayout(layout.ldef, 'ldef')
  layoutScriptData?.refresh()
}
// 元素铺满整个屏幕
export function coverScreen(
  node: qc.Node,
  options?: { width: number; height: number },
) {
  let width, height
  if (options) {
    width = options.width
    height = options.height
  } else {
    if (store.state.workspace.game.device.orientation === 1) {
      width = gameIframe.UIRoot.width
      height = gameIframe.UIRoot.height
    } else {
      width = gameIframe.UIRoot.height
      height = gameIframe.UIRoot.width
    }
  }
  setNodeStyleMergeVH(node, {
    pdef: {
      width: width,
      height: height,
    },
    ldef: {
      width: height,
      height: width,
    },
  })
}
